var _circle, _circle2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLEllipseIc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 100,
    fill: "url(#paint0_radial_829_210)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 99,
    r: 67,
    transform: "rotate(180 100 99)",
    fill: "url(#paint1_radial_829_210)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_829_210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.1538 57.6923) rotate(38.8534) scale(177.799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108,
    stopColor: "#3B3FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopColor: "#2D32B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#2C30B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.994792,
    stopColor: "#373EFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_829_210",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(63.9231 70.6538) rotate(38.8534) scale(119.125)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566108,
    stopColor: "#3B3FB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.661829,
    stopColor: "#2D32B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.822917,
    stopColor: "#2C30B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#484CBB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLEllipseIc);
export default __webpack_public_path__ + "static/media/lEllipse_ic.387f879579f69fc988f50fdf696ad109.svg";
export { ForwardRef as ReactComponent };